import { toast } from "sonner";
import { Film } from "lucide-react";
import MissionShell from "../MissionShell";
import { Card, Field, CheckItem, ProgressBar } from "@/components/kit";
import { MAKING_STEPS } from "../content";
import { useProgress } from "../store";
import { isDone, REQUIREMENTS, stepsCount } from "../logic";

export default function Mission6() {
  const { state, update, setIn, setCompleted } = useProgress();
  const m = state.m6;
  const n = stepsCount(state);
  return (
    <MissionShell
      id={6}
      done={isDone(state, 6)}
      validate={{ label: "Ma vidéo est prête", missing: REQUIREMENTS[6](state), onClick: () => { setCompleted(6, true); toast.success("Ta vidéo est prête. Mission 06 validée !"); } }}
    >
      <div className="space-y-5">
        <Card>
          <div className="flex items-center justify-between gap-3">
            <h3 className="flex items-center gap-2 text-xl font-medium text-ink"><Film className="h-5 w-5 text-bx" strokeWidth={1.5} />Tutoriel guidé</h3>
            <span className="text-sm text-soft" data-testid="steps-count">{n}/9 étapes</span>
          </div>
          <ProgressBar value={Math.round((n / 9) * 100)} className="mt-4" />
          <ol className="mt-5 space-y-2.5">
            {MAKING_STEPS.map((s, i) => (
              <li key={s.id}>
                <CheckItem checked={m.steps[s.id]} onChange={(v) => setIn("m6", "steps", s.id, v)} label={`${i + 1}. ${s.label}`} desc={s.desc} testId={`making-step-${i + 1}`} />
              </li>
            ))}
          </ol>
        </Card>
        <Card className="space-y-5">
          <Field label="Mon outil de montage" value={m.tool} onChange={(v) => update("m6", { tool: v })} placeholder="Ex. : CapCut, l'éditeur de mon téléphone…" testId="editing-tool-input" />
          <Field label="Où ai-je enregistré ma vidéo ?" hint="Ta vidéo reste sur ton appareil : UGC GO ne l'héberge pas." value={m.location} onChange={(v) => update("m6", { location: v })} placeholder="Ex. : Galerie du téléphone, album « UGC »" testId="video-location-input" />
          <p className="text-xs text-soft">Enregistrement automatique dans ton compte.</p>
        </Card>
      </div>
    </MissionShell>
  );
}
